export const holidayTypes = [
  { value: "GOVERNMENT", label: "Government Holiday", color: "#3E8BFF" },
  { value: "HOLIDAY", label: "Weekly Holiday", color: "#6B7280" },
  { value: "EVENTS", label: "Event", color: "#C026D3" },
  { value: "FESTIVAL", label: "Festival", color: "#00C897" },
];
